import { useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import Link from "next/link";
import MenuIcon from "@mui/icons-material/Menu";
import UptimelineLogo from "components/Logo/logo";
import MarvyVerticalMenu from "components/atoms/MarvyVerticalMenu";

export default function MarvyNavbar({
  noMenu,
  noHomeLink,
  authenticated,
  unauthenticated,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuItems = authenticated
    ? [
        {
          label: "Monitors",
          href: "/dashboard/",
        },
        {
          label: "Status Pages",
          href: "/dashboard/status-pages",
        },
        {
          label: "Settings",
          href: "/dashboard/settings",
        },
        {
          label: "Logout",
          href: "/logout",
        },
      ]
    : [
        {
          label: "Home",
          href: "/",
        },
        {
          label: "Log in",
          href: "/auth/login",
        },
        {
          label: "Register",
          href: "/auth/register",
        },
        {
          label: "Blog",
          href: "https://blog.uptimeline.com",
        },
      ];
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          alignSelf: "stretch",
          height: {
            xs: 70,
            sm: 90,
          },
          paddingX: "12px",
          backgroundColor: "dark.main",
          color: "white",
        }}
        component="nav"
      >
        {noHomeLink ? (
          <UptimelineLogo
            style={{
              height: 31,
            }}
          />
        ) : (
          <Link href={unauthenticated ? "/" : "/dashboard"}>
            <UptimelineLogo
              style={{
                height: 31,
                cursor: "pointer",
              }}
            />
          </Link>
        )}
        {noMenu ? null : (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box
                sx={{
                  display: {
                    xs: "flex",
                    sm: "none",
                  },
                }}
              >
                <IconButton onClick={() => setMenuOpen(!menuOpen)}>
                  <MenuIcon sx={{ color: "white.main" }} />
                </IconButton>
              </Box>
              <Box
                sx={{
                  display: {
                    xs: "none",
                    sm: "flex",
                    gap: "20px",
                  },
                }}
              >
                {menuItems.map((item, i) => {
                  return (
                    <Link key={`menu_item_${i}`} href={item.href}>
                      <Typography
                        sx={{
                          fontSize: 16,
                          fontWeight: 700,
                          cursor: "pointer",
                          color: "white.main",
                        }}
                      >
                        {item.label}
                      </Typography>
                    </Link>
                  );
                })}
              </Box>
            </Box>
          </>
        )}
      </Box>
      {!menuOpen ? null : (
        <MarvyVerticalMenu
          sx={{
            display: {
              xs: "flex",
              sm: "none",
            },
          }}
          items={menuItems}
        />
      )}
    </>
  );
}
